import { sup } from '@render-mark/sup'
import { isString } from '@utils/utils'
import React, { useId } from 'react'
import replace from 'string-replace-to-array'

export const renderText = (text: string) =>
  replace(text, /\^([()0-9*]*)*\^/g, (text, offset) => sup(offset)).map(
    (text) => {
      if (isString(text)) {
        return replace(text, /\n/g, () => {
          const id = useId()
          return <br key={id} />
        })
      }

      return text
    }
  )
